import { useEffect } from 'react';

import { authQueries } from '@/api/common/auth';
import { useAuthStore } from '@/stores/useAuthStore';
import { useQuery } from '@tanstack/react-query';

/**
 * PROTOTYPE / MOCK MODE ONLY
 *
 * Replaces ClerkProvider + AuthProvider + OrganizationProvider + ClerkAxiosSetup
 * in mock mode. Fetches user data from MSW-intercepted /api/site/whoami endpoint
 * and populates the auth store directly - no Clerk dependency.
 */

interface MockAuthProviderProps {
  children: React.ReactNode;
}

export const MockAuthProvider: React.FC<MockAuthProviderProps> = ({ children }) => {
  const { setClerkAuth, setUser, setLoadingUserData } = useAuthStore();

  const {
    data: whoAmIData,
    isLoading,
    error
  } = useQuery({
    ...authQueries.whoAmI(),
    enabled: true
  });

  useEffect(() => {
    // In mock mode, we're always "signed in" and "loaded"
    setClerkAuth(true, true);

    if (isLoading) {
      setLoadingUserData(true);
      return;
    }

    if (error || !whoAmIData) {
      setUser(null);
    } else {
      setUser(whoAmIData.Security.User);
    }
  }, [whoAmIData, isLoading, error, setClerkAuth, setUser, setLoadingUserData]);

  return <>{children}</>;
};
